import {Helmet} from 'react-helmet';
import AboutUs from "../aboutus";
import Contact from "../contact";

const faqsContent = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "How much do you charge for website design and development?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Pricing depends on your requirements. Basic websites start from ₹10,000. For dynamic or eCommerce websites, the cost will vary. Contact me for a free quote."
      }
    },
    {
      "@type": "Question",
      "name": "How long does it take to build a website?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Most websites are completed within 7–15 working days. Timeline depends on the number of pages and features required."
      }
    },
    {
      "@type": "Question",
      "name": "Do you offer mobile-friendly (responsive) website design?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, every website I design is fully responsive and optimized for all screen sizes including mobiles, tablets, and desktops."
      }
    },
    {
      "@type": "Question",
      "name": "Can I update my website myself after it’s launched?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, if you choose a CMS-based website (like WordPress), I will provide you with login access and training to manage the content yourself."
      }
    },
    {
      "@type": "Question",
      "name": "Is SEO included with website design?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Basic on-page SEO such as title tags, meta descriptions, image optimization, and speed optimization is included. Advanced SEO services are also available."
      }
    },
    {
      "@type": "Question",
      "name": "Do you provide domain and hosting services?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I can help you purchase a domain and suggest reliable hosting providers. I also offer full setup and configuration support."
      }
    },
    {
      "@type": "Question",
      "name": "Do you work with international clients?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I work remotely and serve clients across India and internationally. Communication is done via WhatsApp, email, or Zoom."
      }
    }
  ]
}

function App1() {
  return (
   <>
   <Helmet>
    <script type="application/ld+json">
          {JSON.stringify(faqsContent)}
        </script>
<title>Website Design and Development Company in Gurgaon | Pankaj</title>
<meta name="description" content="Professional website design and development services in Gurgaon by Pankaj. Mobile-friendly, SEO-ready websites tailored for businesses in Delhi, Noida & India-wide." />
<meta name="keywords" content="website design gurgaon, website development company in gurgaon, freelance web developer, responsive web design, custom website development, web designer in delhi ncr, website development gurgaon, web development services, best web designer near me" />
<meta property="og:title" content="Website Design and Development Company in Gurgaon | Pankaj" />
<meta property="og:description" content="Offering modern, SEO-optimized website design and development in Gurgaon. Build fast, responsive websites that convert visitors into customers." />
<meta property="og:site_name" content="Pankaj | Freelance Website Developer" />
<meta property="og:url" content="https://www.pankj.com/website-design-development" />
<meta property="og:image" content="https://www.pankj.com/assets/img/dpnew.jpg" />
<meta name="twitter:image" content="https://www.pankj.com/assets/img/dpnew.jpg" />
<meta name="twitter:title" content="Website Design and Development Company in Gurgaon | Pankaj" />
<meta name="twitter:description" content="Need a custom website? Get expert website design and development services in Gurgaon. Affordable and professional." />
<link rel="canonical" href="https://www.pankj.com/website-design-development" />
</Helmet>
    <section id="hero" className="hero d-flex align-items-center fixedabove">
   <video
                className="mainsliderbg"
                autoPlay
                muted
                loop={true} style={{width:'100%'}}>
{/*                <source src="assets/img/bg.mp4" type="video/mp4" />*/}
                <source src="assets/img/pankaj-web-designer2.mp4" type="video/mp4" />
                <source src="bg.ogg" type="video/ogg" />
  </video>
<div className="mainsliderbg">
     <div className="container-fluid">
      <div className="row">
        <div className="col-lg-6 d-flex flex-column">
            <img src="../assets/img/thyear.webp" className="imgsz" alt="Website Designer" />

 <h1 className="multiple_effects fzsml" id="text3d">Website Design & Development</h1>
          <div className="content_sec" data-aos="fade-up" data-aos-delay="400">Take a look at some of my works, and if you like them, feel free to contact me.</div>
  <div data-aos="fade-up" data-aos-delay="600">
            <div className="text-center text-lg-start">
              <a href="https://api.whatsapp.com/send?phone=917838704822&text=Hello%20Pankaj" target="_blank" rel="noreferrer" className="btn-get-started scrollto d-inline-flex align-items-center justify-content-center align-self-center">
                <span>WhatsApp</span>
                <i className="bi bi-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="col-lg-6 hero-img" data-aos="zoom-out" data-aos-delay="200">
              <div className="img-area">
      <div className="inner-area">
        <img src="../assets/img/123.png" alt="best web designer in gurgaon" />
      </div>
    </div>
        </div>
      </div>
    </div> 
</div>
  </section>   
    <main id="main">
 <section id="pageContent" className="pageContent">
      <div className="container" data-aos="fade-up">
        <header className="section-header">
          <h2>Website Design and Development</h2>
        </header>
        <div className="row">
          <div className="col-lg-12">
<div class="hero-section">
  <div class="container">
    <p>Professional, responsive, and SEO-ready websites tailored to your business goals. Serving clients in Gurgaon, Delhi, Noida, and worldwide.</p>
    <a href="/contact" class="btn btn-primary mt-3">Get a Free Quote</a>
  </div>
</div>

<div class="intro-section">
  <div class="container">
    <h2>Custom Website Design & Development Services</h2>
    <p>I’m <strong>Pankaj Singh</strong>, a freelance website designer and full-stack developer based in Gurgaon with 11+ years of experience. I help startups, small businesses, and agencies launch professional websites that drive results.</p>
  </div>
</div>

<div class="services-section py-5">
  <div class="container">
    <h2>What’s Included in My Web Design Services</h2>
    <ul>
      <li>✅ Custom Design (No Templates)</li>
      <li>✅ Responsive for Mobile, Tablet & Desktop</li>
      <li>✅ SEO-Friendly Structure</li>
      <li>✅ Fast Loading Speed</li>
      <li>✅ WordPress / PHP / React Options</li>
      <li>✅ Contact Forms, WhatsApp Integration</li>
      <li>✅ Domain & Hosting Assistance</li>
      <li>✅ CMS Panel to Manage Content</li>
    </ul>
  </div>
</div>


    <h2>Why Choose Me?</h2>
    <p>✔ Over <strong>1000+ websites</strong> built across industries<br/>
       ✔ 100% freelance service — no agency overhead<br/>
       ✔ Support after delivery and maintenance plans<br/>
       ✔ Competitive pricing with on-time delivery<br/>
       ✔ Easy communication via WhatsApp, Email, Zoom</p>


<div class="faqs-section py-5">
  <div class="container">
    <h2>Website Design & Development FAQs</h2>

    <div class="faq-item">
      <h4>How much do you charge for website design and development?</h4>
      <p>Pricing starts from ₹10,000 for basic websites. Dynamic or eCommerce websites cost more based on features.</p>
    </div>

    <div class="faq-item">
      <h4>How long does it take to complete a website?</h4>
      <p>Usually between 7–15 working days depending on scope and content availability.</p>
    </div>

    <div class="faq-item">
      <h4>Will my website be mobile-friendly?</h4>
      <p>Yes, I design responsive websites that look great on all devices.</p>
    </div>

    <div class="faq-item">
      <h4>Can I edit my website myself?</h4>
      <p>Yes, I offer CMS-based sites where you can easily manage pages, images, and content.</p>
    </div>

    <div class="faq-item">
      <h4>Is SEO included in the website package?</h4>
      <p>Basic SEO (meta tags, fast load time, image optimization) is included. Advanced SEO is offered separately.</p>
    </div>
  </div>
</div>

<div class="cta-section text-center py-5">
  <div class="container">
    <h2>Ready to Launch Your Website?</h2>
    <p>Contact me today to get a professional, high-performing website that converts visitors into customers.</p>
    <a href="/contact" class="btn btn-success mt-3">Request a Free Consultation</a>
  </div>
</div>

          </div>
        </div>
      </div>

    </section>
    <Contact /> 
    </main>
    </>
  );
}
export default App1;
